class SortingRadios {
  constructor(context, settings, $) {
    this.element = document.querySelector(".c-sorting-radios");
    if (this.element === null) {
      return;
    }

    const parentForm = this.element.closest("form");
    
    const radios = this.element.querySelectorAll("input");
    radios.forEach((radio) =>
      radio.addEventListener("change", () => {
        if (radio.checked) {
          const radioSummaryText = radio.getAttribute("data-summary-text");
          this.setSummaryText(radioSummaryText);
        }
        
        if (parentForm) {
          parentForm.submit();
        }
      })
    );
  }

  setSummaryText(text) {
    const summaryText = this.element.querySelector(
      ".c-sorting-radios__summary-text"
    );
    if (summaryText) {
      summaryText.textContent = `(${text})`;
    }
  }
}

export default SortingRadios;
